import styled from "styled-components";
import { Outlet } from "react-router-dom"
import NavigationReventas from "./navigationReventas.jsx"
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';



const Container=styled.div`
	position:relative;
	height:100vh;
	width:100vw;
	overflow:hidden;
	background-color:black;
 `;

const ContainerNav=styled.div`
	display:flex;
	align-items:center;
	background-color:#050505;
	height:70px;
 `;




let BackdropCarga=styled.div`
	height:81%;
	width:100%;
	position:absolute;
	background-color:black;
	z-index:5;
	opacity:0.8;
	display:flex;
	justify-content:center;
	align-items:center
`;

 export default function ReventasAdmin(){
	

	let reventasEstado=useSelector(state=>state.reventa.reventasEstado);

 	return(
 		<Container>
 			<ContainerNav>
 				<NavigationReventas/> 								
 			</ContainerNav>
 			{reventasEstado==2?<BackdropCarga><CircularProgress size="6rem" /> </BackdropCarga>:null}
 			<Outlet/>
 		</Container>


 		)
 }